import { Injectable, inject, DOCUMENT } from '@angular/core';
import { Observable, Subscriber } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ScriptLoaderService {
  private readonly _document: Document = inject<Document>(DOCUMENT);

  public load(
    src: string,
    async: boolean = true
  ): Observable<HTMLScriptElement> {
    return new Observable<HTMLScriptElement>(
      (observer: Subscriber<HTMLScriptElement>) => {
        const script: HTMLScriptElement =
          this._document.createElement('script');

        script.setAttribute('type', 'text/javascript');
        script.setAttribute('src', src);

        if (async) {
          script.setAttribute('async', 'true');
        }

        script.onload = (): void => {
          observer.next(script);
          observer.complete();
        };

        script.onerror = (): void => {
          observer.error();
        };

        this._document.head.appendChild(script);

        return {
          unsubscribe: (): void => {},
        };
      }
    );
  }

  public loadCSS(
    href: string,
    async: boolean = true
  ): Observable<HTMLLinkElement> {
    return new Observable<HTMLLinkElement>(
      (observer: Subscriber<HTMLLinkElement>) => {
        const link: HTMLLinkElement = this._document.createElement('link');

        link.setAttribute('rel', 'stylesheet');
        link.setAttribute('type', 'text/css');
        link.setAttribute('href', href);

        // Chargement non-bloquant grâce à un media query trick
        if (async) {
          link.setAttribute('media', 'print');
          link.onload = (): void => {
            link.setAttribute('media', 'all');
            observer.next(link);
            observer.complete();
          };
        } else {
          link.onload = (): void => {
            observer.next(link);
            observer.complete();
          };
        }

        link.onerror = (): void => {
          observer.error();
        };

        this._document.head.appendChild(link);

        return {
          unsubscribe: (): void => {},
        };
      }
    );
  }

  public remove(ref: HTMLScriptElement): void {
    ref.remove();
  }

  public removeCSS(ref: HTMLLinkElement): void {
    ref.remove();
  }
}
